module.exports = __webpack_public_path__ + "static/hero5_mob-bbfba76bc3ca0bc73a39e31377352e19.jpg";